import { status } from 'skin/event/status';
import { kit } from 'skin/data/message';
import { message } from 'skin/event';

const master = (obj, ms, story, data, d, action) => {
	const make = data.s.genStep.values.fld.make
	const fact = 'используя счетчик веса'
	const o = {
		type: 'master',
		action: 'check'
	}
	const aBtn = kit('yesno');
	aBtn[0].action = _ => action(o)
	console.log(make, fact);
	make === fact ?
	action(o)
	:
	message(
		`Тип весового товара "${make}" будет изменен на "${fact}". Продолжить?`,
		'Ячейки',
		aBtn,
		'?'
	)
	return status.ignore
}

export default master